import type { AppShellBounds } from './AppShellContext.ts';
import { useMemo, useState } from 'react';
import { useBoolean } from 'usehooks-ts';
import { AppShellContext } from './AppShellContext.ts';

export function AppShellProvider({ children }: React.PropsWithChildren) {
  const mobileSearch = useBoolean(false);

  const [bounds, setBounds] = useState<AppShellBounds>({
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  } as AppShellBounds);

  return (
    <AppShellContext
      value={useMemo(
        () => ({
          appShellBounds: {
            bottom: bounds.bottom || 0,
            left: bounds.left || 0,
            right: bounds.right || 0,
            top: bounds.top || 0
          },
          mobileSearch: {
            close: mobileSearch.setFalse,
            isOpen: mobileSearch.value,
            open: mobileSearch.setTrue
          },
          setAppShellBounds: setBounds
        }),
        [bounds, mobileSearch]
      )}
    >
      {children}
    </AppShellContext>
  );
}
